import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Link } from "react-router-dom";
import TextField from "@material-ui/core/TextField";

class SubscriptionContainer extends Component {
  state = {
    user: {},
    userNotFound: false,
  };

  UNSAFE_componentWillMount = () => {
    window.firebase
      .firestore()
      .collection("users")
      .doc(this.props.uid)
      .onSnapshot((doc) => {
        let user = doc.data();
        if (user) {
          user["id"] = doc.id;
          this.setState({ user: user });
        } else {
          this.setState({ userNotFound: true });
        }
      });
  };

  handleNotesChange = (e) => {
    window.firebase
      .firestore()
      .collection("userStatus")
      .doc(this.props.uid)
      .update({ notes: e.target.value });
  };

  render() {
    if (this.state.userNotFound) {
      return null;
    }
    return (
      <TableRow>
        <TableCell>
          <Link to={"/admin/" + this.props.uid}>{this.props.uid}</Link>
        </TableCell>
        <TableCell>{this.state.user.email || ""}</TableCell>
        <TableCell>{this.state.user.name || ""}</TableCell>
        <TableCell>{this.props.package}</TableCell>
        <TableCell>
          <TextField
            style={{ width: 300 }}
            value={this.props.notes || ""}
            onChange={this.handleNotesChange}
          />
        </TableCell>
      </TableRow>
    );
  }
}

export default SubscriptionContainer;
